export default "__VITE_ASSET__5bc547aa__"